import MapLayer from "../models/mapLayer";
import MapLayerIndex from "../models/mapLayerIndex";
import MapLayerType from "../models/mapLayerType";
import MapLayerVisibility from "../models/mapLayerVisibility";
import TableColum from "../models/tableColumn";
import ThematicMapLayerRange from "../models/thematicMapLayerRange";
import unitConverter from "../util/units/unitConverter";
import httpService from "./httpService";

const apiEndpoint = "/mapLayers";

const getMapLayers = async (
  idProject: number,
  tableColumns: TableColum[],
): Promise<MapLayer[]> => {
  const { data: mapLayers } = await httpService.get<MapLayer[]>(
    `${apiEndpoint}/getMapLayers?idProject=${idProject}`,
  );

  // fix units for thematic layers

  for (const mapLayer of mapLayers) {
    if (mapLayer.mapLayerType !== MapLayerType.ThematicLayer) {
      continue;
    }

    if (!mapLayer.thematicMapLayer) {
      continue;
    }

    const fieldName = mapLayer.thematicMapLayer.fieldName;

    const tableColumn = tableColumns.find((c) => c.columnName === fieldName);

    if (!tableColumn) {
      continue;
    }

    fixRangesDisplayValues(
      mapLayer.thematicMapLayer.thematicMapLayerRanges,
      tableColumn,
    );

    if (mapLayer.parentMapLayer && mapLayer.parentMapLayer.thematicMapLayer) {
      const linkedFieldName =
        mapLayer.parentMapLayer.thematicMapLayer.fieldName;

      const linkedTableColumn = tableColumns.find(
        (c) => c.columnName === linkedFieldName,
      );

      if (!linkedTableColumn) {
        continue;
      }

      fixRangesDisplayValues(
        mapLayer.parentMapLayer.thematicMapLayer.thematicMapLayerRanges,
        linkedTableColumn,
      );
    }
  }

  return Promise.resolve(mapLayers);
};

const fixRangesDisplayValues = (
  thematicMapLayerRanges: ThematicMapLayerRange[],
  tableColumn: TableColum,
) => {
  for (const range of thematicMapLayerRanges) {
    if (range.hasRangeStart) {
      range.rangeStartDisplayValue = unitConverter.convertValue(
        range.rangeStartValue,
        tableColumn.unitMeasure,
      );
    }

    if (range.hasRangeEnd) {
      range.rangeEndDisplayValue = unitConverter.convertValue(
        range.rangeEndValue,
        tableColumn.unitMeasure,
      );
    }
  }
};

const fixRangesDisplayValuesNoUnitConversion = (
  thematicMapLayerRanges: ThematicMapLayerRange[],
) => {
  for (const range of thematicMapLayerRanges) {
    if (range.hasRangeStart) {
      range.rangeStartDisplayValue = range.rangeStartValue;
    }

    if (range.hasRangeEnd) {
      range.rangeEndDisplayValue = range.rangeEndValue;
    }
  }
};

const createMapLayer = (mapLayer: MapLayer) => {
  return httpService.post(`${apiEndpoint}/createMapLayer`, mapLayer);
};

const updateMapLayer = (mapLayer: MapLayer) => {
  return httpService.post(`${apiEndpoint}/updateMapLayer`, mapLayer);
};

const deleteMapLayer = (idMapLayer: number) => {
  var data = new FormData();
  data.append("idMapLayer", idMapLayer.toString());
  return httpService.post(`${apiEndpoint}/deleteMapLayer`, data);
};

const updateMapLayerVisibilities = (
  mapLayerVisibilities: MapLayerVisibility[],
) => {
  return httpService.post(
    `${apiEndpoint}/updateMapLayerVisibilities`,
    mapLayerVisibilities,
  );
};

const updateMapLayerIndexes = (mapLayerIndexes: MapLayerIndex[]) => {
  return httpService.post(
    `${apiEndpoint}/updateMapLayerIndexes`,
    mapLayerIndexes,
  );
};

const mapLayerService = {
  getMapLayers,
  createMapLayer,
  updateMapLayer,
  deleteMapLayer,
  updateMapLayerVisibilities,
  updateMapLayerIndexes,
  fixRangesDisplayValues,
  fixRangesDisplayValuesNoUnitConversion,
};

export default mapLayerService;
